import { useCallback, useEffect, useRef } from 'react'
import { useField, useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { nullAndCustomCloseLostReasonsIds } from '@sales-center/common'

type Props = {
  isOpportunityStageMeter?: boolean
}

export function useFormFields(props: Props) {
  const { isOpportunityStageMeter } = props
  const { setFieldValue, values, setValues } =
    useFormikContext<IAddOpportunityFormModel>()

  const customReasonRef = useRef<HTMLInputElement>()

  const [reasonField] = useField<string>('closedLostReasonId')
  const [customReasonField] = useField<string>('closedLostCustomReason')

  const onFocusCustomReason = useCallback(() => {
    setFieldValue('closedLostReasonId', '0')
  }, [setFieldValue])
  const customReasonHelperText = `Max character limit is 50. Your current count is ${
    customReasonField.value?.length || 0
  }/50`

  const onCancelClick = useCallback(() => {
    setValues((model) => ({
      ...model,
      closedLostReasonId: -1,
      closedLostCustomReason: '',
      opportunityStageId: '',
      opportunityStageName: '',
      opportunityStageClosedLostIdTemp: '',
    }))
  }, [setValues])

  useEffect(() => {
    if (reasonField.value !== '0') {
      setFieldValue('customReason', '')
    } else {
      customReasonRef.current?.focus()
    }
  }, [reasonField.value, setFieldValue])

  useEffect(() => {
    if (
      values.closedLostReasonId?.toString() !== '0' &&
      values.closedLostReasonId?.toString() !== '-1'
    ) {
      setFieldValue('closedLostCustomReason', '')
    }
  }, [values.closedLostReasonId, setFieldValue])

  useEffect(() => {
    if (isOpportunityStageMeter && values.opportunityStageClosedLostIdTemp) {
      if (
        values.closedLostReasonId &&
        !nullAndCustomCloseLostReasonsIds?.includes(
          values.closedLostReasonId?.toString(),
        )
      ) {
        setFieldValue(
          'opportunityStageId',
          values.opportunityStageClosedLostIdTemp,
        )
      } else if (
        values.opportunityStageClosedLostIdTemp &&
        values.closedLostReasonId &&
        values.closedLostReasonId?.toString() == '0' &&
        values.closedLostCustomReason != ''
      ) {
        setFieldValue(
          'opportunityStageId',
          values.opportunityStageClosedLostIdTemp,
        )
      } else {
        setFieldValue('opportunityStageId', '')
      }
    }
  }, [
    values.opportunityStageClosedLostIdTemp,
    values.closedLostReasonId,
    setFieldValue,
    values.closedLostCustomReason,
    isOpportunityStageMeter,
  ])

  return {
    reasonField,
    customReasonRef,
    customReasonField,
    onFocusCustomReason,
    customReasonHelperText,
    onCancelClick,
  }
}
